import React, { useRef } from 'react';

import { IEmployee } from '@entities/employee/model/types';
import { useIsOverflowing } from '@shared/hooks';
import { UiText } from '@shared/ui';

import cls from './EmployeePosition.module.css';

interface IEmployeePositionProps {
    position: IEmployee['position'];
}

export const EmployeePosition = ({ position }: IEmployeePositionProps) => {
    const positionRef = useRef<HTMLSpanElement>(null);
    const { isOverflowing } = useIsOverflowing({ elRef: positionRef });

    if (!position) {
        return null;
    }

    return (
        <span
            className={cls.ellipsisOneLine}
            title={isOverflowing ? position : null}
            ref={positionRef}
        >
            <UiText tag="span" classes={cls.colorTertiary} align="center" variant="captionUpper">
                {position}
            </UiText>
        </span>
    );
};
